// This module provides API calls to the Flask backend for orgs data
import axios from "axios";
import Response from "../response";
import { errCodes } from "../response/errors";
import { BLITZ_CI_AUTH, COMMISSIONS_API_BASE_URL } from "../../utils/constants";

export const defaultWebScraperSchedule = {
  name: "",
  schedule: "0 0 * * *",
  timezone: "UTC",
  client: "",
  carrier: "",
  docType: "",
};

class WebScrapers {
  constructor() {
    this.baseUrl = COMMISSIONS_API_BASE_URL;
    this.endpoint = "scheduler/webscrapers";
    this.url = `${this.baseUrl}/${this.endpoint}`;
    this.headers = {
      'Content-Type': 'application/json',
      'Authorization': '',
    };
  }

  #checkSession() {
    this.accessToken = sessionStorage.getItem(BLITZ_CI_AUTH);
    this.headers['Authorization'] = `Bearer ${this.accessToken}`;
  }

  async getAllWebScrapersSchedule() {
    this.#checkSession();
    try {
      const response = await axios.get(`${this.url}`, { headers: this.headers });
      if (response.status === 200 && Array.isArray(response.data)) {
        return Response.create(response.data, true);
      }
      return Response.create({}, false, {}, errCodes.NotFound);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async getWebScraperSchedule(jobID) {
    this.#checkSession();
    try {
      const response = await axios.get(`${this.url}/${jobID}`, { headers: this.headers });
      if (response.status === 200 && response.data.id) {
        return Response.create(response.data, true);
      }
      return Response.create({}, false, {}, errCodes.NotFound);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async createWebScraperSchedule(data) {
    this.#checkSession();
    try {
      const response = await axios.post(`${this.url}`, data, { headers: this.headers });
      if (response.status === 201 || response.status === 200) {
        return Response.create({}, true);
      }
      return Response.create({}, false, {}, errCodes.Internal);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async updateWebScraperSchedule(jobId, data) {
    this.#checkSession();
    try {
      const response = await axios.patch(`${this.url}/${jobId}`, data, { headers: this.headers });
      if ((response.status === 200 || response.status === 201)) {
        return Response.create(response.data, true);
      }
      return Response.create({}, false, {}, errCodes.Internal);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async deleteWebScraperSchedule(jobId) {
    this.#checkSession();
    try {
      const response = await axios.delete(`${this.url}/${jobId}`, { headers: this.headers });
      if (response.status === 200) {
        return Response.create({ id: jobId }, true);
      }
      return Response.create({}, false, {}, errCodes.Internal);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }
}

export default WebScrapers;